import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { SkeletonRegion, useStableKeys } from './_shared'

export interface CardGridSkeletonProps {
	count?: number
	columns?: 1 | 2 | 3 | 4
	withActions?: boolean
	lines?: number
	className?: string
	cardClassName?: string
	label?: string | false
}

const COLS: Record<number, string> = {
	1: 'grid-cols-1',
	2: 'grid-cols-1 sm:grid-cols-2',
	3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
	4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
}

export function CardGridSkeleton({
	count = 6,
	columns = 3,
	withActions = false,
	lines = 2,
	className,
	cardClassName,
	label = 'Loading',
}: CardGridSkeletonProps) {
	const cardKeys = useStableKeys(count)
	const lineKeys = useStableKeys(lines)
	return (
		<SkeletonRegion label={label} className={cn('grid gap-4', COLS[columns], className)}>
			{cardKeys.map(key => (
				<Card key={key} className={cn('gap-4 py-4', cardClassName)}>
					<CardHeader className='gap-2'>
						<Skeleton className='h-5 w-1/2' />
						<Skeleton className='h-4 w-3/4' />
					</CardHeader>
					<CardContent className='space-y-2'>
						{lineKeys.map(lineKey => (
							<Skeleton key={lineKey} className='h-4 w-full' />
						))}
						{withActions ? (
							<div className='flex gap-2 pt-2'>
								<Skeleton className='h-8 w-20' />
								<Skeleton className='h-8 w-20' />
							</div>
						) : null}
					</CardContent>
				</Card>
			))}
		</SkeletonRegion>
	)
}
